'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var nthHookTheme = require('@narvar/nth-hook-theme');
var React = require('react');
var styled = require('styled-components');
var style = require('../utils/style.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ChipStyled = styled__default["default"].button.withConfig({
  componentId: "sc-1a2af0b-0"
})(_ref => {
  let {
    s,
    sActive,
    sHover,
    as
  } = _ref;
  return {
    borderRadius: '1rem',
    color: '#5C5C5F',
    fill: '#5C5C5F',
    margin: 0,
    padding: '0.25rem 0.75rem',
    borderStyle: 'solid',
    display: 'inline-flex',
    gap: '0.25rem',
    alignItems: 'center',
    ...s,
    ...((!as || as === 'a' || as === 'button') && {
      cursor: 'pointer',
      '&:hover, &:focus': {
        background: '#f9f9f9',
        ...sHover
      },
      '&:active': {
        ...sActive
      }
    })
  };
});
const Chip = _ref2 => {
  let {
    as,
    s,
    sHover,
    sActive,
    ...rest
  } = _ref2;
  const {
    panelcontainerNoneNone,
    panelcontainerNoneActive,
    panelcontainerNoneHover
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(ChipStyled, _extends__default["default"]({
    as: as,
    s: {
      borderWidth: style.getBorderWidth(panelcontainerNoneNone),
      borderColor: style.getBorderColor(panelcontainerNoneNone),
      background: panelcontainerNoneNone === null || panelcontainerNoneNone === void 0 ? void 0 : panelcontainerNoneNone.backgroundColor,
      ...s
    },
    sHover: {
      ...panelcontainerNoneHover,
      ...sHover
    },
    sActive: {
      ...panelcontainerNoneActive,
      ...sActive
    }
  }, rest));
};
var Chip$1 = nthHookTheme.withThemeProvider(Chip, {
  themeTokens: ['panelcontainerNoneNone', 'panelcontainerNoneHover', 'panelcontainerNoneActive']
});

exports["default"] = Chip$1;
